module.exports = "<span>\r\n  &copy;\r\n</span>\r\n\r\n<span>\r\n  {{::$ctrl.copyrightYear}} Brightstar Lottery.\r\n</span>\r\n\r\n<translate>\r\n  All rights reserved.\r\n</translate>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-copyright/rw-copyright.html
// module id = 1942
// module chunks = 0